import { render } from "./GroupDesktop.vue?vue&type=template&id=00869eb5&scoped=true"
import script from "./GroupDesktop.vue?vue&type=script&lang=js"
export * from "./GroupDesktop.vue?vue&type=script&lang=js"

import "./GroupDesktop.vue?vue&type=style&index=0&id=00869eb5&lang=less&scoped=true"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/jb/jb-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00869eb5"]])

export default __exports__